export const getValidPageIndex = (pageIndexParameter: string | undefined) => {
  const numberValue = Number(pageIndexParameter) || 0;
  return numberValue > 0 ? numberValue : 0;
};
